import { render, staticRenderFns } from "./gc-popup-sales-order-split.vue?vue&type=template&id=d06d1b02&scoped=true"
import script from "./gc-popup-sales-order-split.vue?vue&type=script&lang=js"
export * from "./gc-popup-sales-order-split.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-sales-order-split.vue?vue&type=style&index=0&id=d06d1b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06d1b02",
  null
  
)

export default component.exports